<div *ngIf="services">
  <micro-picklist title="Services" idField="service" displayField="service" [all]="services" [(selectedIds)]="selectedServices" (selectedIdsChange)="onNgModelChange($event)" [helpCallback]="helpCallback" [component]="this"></micro-picklist>
</div>
